/* eslint-disable @nx/enforce-module-boundaries */
import { SmileyIcon } from '@mybridge/icons';
import { Emoji } from '@mybridge/ui/emoji';
import { useDisclosure } from '@mybridge/ui/hooks';
import { IconButton } from '@mybridge/ui/icon-button';
import { Box } from '@mybridge/ui/layout';
import { Popover, PopoverContent, PopoverTrigger } from '@mybridge/ui/popover';
import { Tooltip } from '@mybridge/ui/tooltip';
import { useContext } from 'react';
import { TeamsContext } from '../../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const EmojiPicker = ({ ...props }) => {
  const { setText, text, textInputRef } = useContext(TeamsContext);
  const emojiDisc = useDisclosure();
  const { t } = useTranslator();
  const insertAtPos = (value) => {
    const { current: ref } = textInputRef ?? {};
    if (ref) {
      /*
      let startPos = ref.selectionStart;
      let endPos = ref.selectionEnd;
      const text_ =
        ref.value.substring(0, startPos) +
        value.native +
        ref.value.substring(endPos, ref.value.length);
      setText(text_);
      */
      if (typeof ref.insertContent === 'function' || ref.commands) {
        ref.chain().focus().insertContent(value.native).run();
      } else {
        let startPos = ref.selectionStart;
        let endPos = ref.selectionEnd;
        const text_ =
          ref.value.substring(0, startPos) +
          value.native +
          ref.value.substring(endPos, ref.value.length);
        setText(text_);
      }
    }
  };
  return (
    <>
      <Popover {...emojiDisc}>
        <PopoverTrigger>
          <Box>
            <Tooltip variant="round" label={t('myMessages.addEmoji') || "Add Emoji"}>
              <IconButton
                variant="ghost"
                icon={
                  <SmileyIcon color={props?.color ? props?.color : '#3D5A80'} />
                }
              />
            </Tooltip>
          </Box>
        </PopoverTrigger>
        <PopoverContent>
          {emojiDisc.isOpen ? <Emoji onEmojiSelect={insertAtPos} /> : ''}
        </PopoverContent>
      </Popover>
    </>
  );
};
